const topicItems = [
  { label: '#科幻电影', count: '2.3万讨论' },
  { label: '#悬疑推理', count: '1.8万讨论' },
  { label: '#古装大剧', count: '3.1万讨论' },
  { label: '#国漫崛起', count: '2.7万讨论' },
  { label: '#刑侦剧集', count: '1.5万讨论' },
  { label: '#爱情文艺', count: '1.2万讨论' },
  { label: '#纪录片', count: '9.8千讨论' },
  { label: '#动作冒险', count: '2.1万讨论' },
  { label: '#高分经典', count: '4.5万讨论' },
  { label: '#热门综艺', count: '3.8万讨论' },
  { label: '#奇幻大片', count: '1.6万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            糖心影视社区正在热议的影视话题，加入讨论发现同好
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((topic) => (
            <a
              key={topic.label}
              href="#ranking"
              className="group flex items-center gap-3 px-5 py-3 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300/60 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="font-heading text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-[11px] md:text-xs text-foreground-500 bg-background-200/70 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}